import Card from "./elements/Card"

const FakeMemory = () => {
	const TimeToRender = 12

	return (
		<div className="relative max-w-3xl mx-auto">
			<div className="grid grid-cols-3 md:grid-cols-4 gap-6 px-6 pointer-events-none opacity-30">
				{Array.from({ length: TimeToRender }).map((_, index) => (
					<Card cardKey={index} key={index} front={<img src="images/card.png" alt="" />} />
				))}
			</div>
		</div>
	)
}

export default FakeMemory
